export default "__VITE_ASSET__DJ6Hoqg$__"